import React from 'react';
import PropTypes from 'prop-types';

import 'react-phone-input-2/lib/material.css';
import PhoneInput from 'react-phone-input-2';

import {
	FormHelperText,
} from '@material-ui/core';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslation } from '@common/utils';

function PhoneInputForm({ setFieldValue, props, prop, errors, handleBlur, touched, required, label }) {
	const classes = useStyles();
	const tr = useTranslation();

	const { value } = props || {};

	return (
		<>
			<PhoneInput
				containerClass={classes.conteiner}
				containerStyle={{ color: (touched[prop] && Boolean(errors[prop])) ? '#f44336' : '' }}
				inputStyle={{ width: '100%', padding: '14px 14px 14px 58px', borderRadius: '4px', border: (touched[prop] && Boolean(errors[prop])) ? '1px solid #f44336' : '' }}
				dropdownStyle={{ width: '265px' }}
				searchStyle={{ width: '94%' }}
				inputProps={{
					required: required,
				}}
				specialLabel={label ? `${label} ${required ? '*' : ''}` : `${tr('Phone')} ${required ? '*' : ''}`}
				country={'lt'}
				value={value}
				enableSearch={true}
				onBlur={handleBlur(prop)}
				onChange={phone => setFieldValue(prop, phone, true)} />
			{touched[prop] && Boolean(errors[prop]) && (
				<FormHelperText error={true}>
					{errors[prop]}
				</FormHelperText>
			)}
		</>
	);
}

PhoneInputForm.propTypes = {
	values: PropTypes.object,
	setFieldValue: PropTypes.func,
	props: PropTypes.object,
	prop: PropTypes.string.isRequired,
	errors: PropTypes.object,
	handleBlur: PropTypes.func,
	touched: PropTypes.object,
	required: PropTypes.bool,
	label: PropTypes.string,
};

export default PhoneInputForm;

const useStyles = makeStyles(({
	conteiner: {
		width: '100%',
		padding: 0,
		color: 'rgba(0, 0, 0, 0.54)',
	},
}));
